const ROLES = {
    admin: 'ROLE_ADMIN',
    partner: 'ROLE_PARTNER',
    cc: 'ROLE_CC_AGENT',
    user: 'ROLE_USER',
    partner_manager: 'ROLE_PARTNER_MANAGER',
};

const PARTNER_MANAGER_DETAILS_TYPE = {
    EXTERNAL: 'EXTERNAL',
    EXTERNAL_WWB: 'EXTERNAL_WWB',
    ADMIN: 'ADMIN',
    ADMIN_READ_ONLY: 'ADMIN_READ_ONLY',
};

const PARTNER_MANAGER_CONTROL = {
    ADMIN: 'ADMIN',
    NORMAL: 'NORMAL',
};

const APPLIANCE_TYPE = {
    washer: 'WASHING_MACHINE',
    dryer: 'DRYER',
};
const LANGS = {
    eng: 'eng',
    ger: 'ger',
};

const CONTROL_TYPE = {
    power: 'POWER',
    powerConstant: 'POWER_CONSTANT',
    paymentSignal: 'PAYMENT_SIGNAL',
    paymentSignalFullDuration: 'PAYMENT_SIGNAL_FULL_DURATION',
    paymentSignalDuringLoading: 'PAYMENT_SIGNAL_DURING_LOADING',
};

const ACCOUNTING_STATUS = {
    internal: 'INTERNAL',
    filed: 'FILED',
    filedWarning: 'FILED_WARNING',
    corrected: 'CORRECTED',
    correctedWarning: 'CORRECTED_WARNING',
};

const CORRECTED_ACCOUNTING_STATES = [
    ACCOUNTING_STATUS.corrected,
    ACCOUNTING_STATUS.correctedWarning,
];

const VAT_EXEMPTION_REASONS = {
    SUBJECT_TO_VAT: 'SUBJECT_TO_VAT',
    VAT_EXEMPT: 'VAT_EXEMPT',
    REVERSE_CHARGE: 'REVERSE_CHARGE',
};

const enums = {
    APPLIANCE_TYPE,
    ROLES,
    LANGS,
    PARTNER_MANAGER_DETAILS_TYPE,
};

export default enums;
export {
    APPLIANCE_TYPE,
    ROLES,
    LANGS,
    PARTNER_MANAGER_DETAILS_TYPE,
    CONTROL_TYPE,
    PARTNER_MANAGER_CONTROL,
    ACCOUNTING_STATUS,
    CORRECTED_ACCOUNTING_STATES,
    VAT_EXEMPTION_REASONS,
};
